import { useLocalStorage } from './useLocalStorage';

export const useLocalFromNegotiator = () => {
  return useLocalStorage('localFromNegotiator', false);
};
